/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from 'react';
import Button from '../../components/@base/Button';
import Modal from '../../components/@base/Modal';
import Scrim from '../../components/@base/Scrim';
import Select from '../../components/@base/Select';
import SelectOption from '../../components/@base/SelectOption';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ContextMenu from '../../components/ContextMenu/ContextMenu';
import ContextSaving from '../../context/SaveContext';

const ConversationFlowFlowSelector = (props) => {
  let value = '';
  const onChangeHandler = (e) => {
    if (e === value) return null;
    const index = props.flows.findIndex((flow) => flow.name === e);
    props.setFlow(index);
    props.setShowFlowSelector(false);
  };
  const options = props.flows.map((flow) => {
    let selected = false;
    if (flow.id === props.activeFlowId) {
      selected = true;
      value = flow.name;
    }
    return (
      <SelectOption selected={selected}>
        {flow.name}
      </SelectOption>
    );
  });

  return (
    <Scrim classes="is-foco">
      <Modal
        title="Escolha o fluxo que gostaria de editar:"
        content={(
          <Select
            value={value}
            width="370px"
            placeholder="Escolha"
            onChange={onChangeHandler}
          >
            {options}
          </Select>
        )}
        buttons={(
          <>
            <Button
              primary
              small
              onClick={() => props.setShowFlowSelector(false)}
            >
              <small>Cancelar</small>
            </Button>
          </>
        )}
      />
    </Scrim>
  );
};

const ConversationFlowBreadCrumbs = (props) => {
  const [showFlowSelector, setShowFlowSelector] = useState(false);
  const saveContext = useContext(ContextSaving);

  const mainButton = (
    <Button
      circle
      small
      disabled={saveContext.savingStatus.isSaving}
    >
      <i className="fa fa-cog fa-sm" aria-hidden="true" />
    </Button>
  );
  const options = [
    <a
      tabIndex={0}
      role="button"
      onClick={() => setShowFlowSelector(true)}
      onKeyPress={() => setShowFlowSelector(true)}
    >
      Trocar fluxo em edição

    </a>];

  return (
    <>
      {showFlowSelector
        && (
          <ConversationFlowFlowSelector
            activeFlowId={props.contextBots.flow.id}
            flows={props.contextBots.flows}
            setFlow={props.contextBots.setFlow}
            setShowFlowSelector={setShowFlowSelector}
          />
        )}
      <Breadcrumbs>

        <span style={{
          alignItems: 'center',
          display: 'flex',
        }}
        >
          <div className="float-left">{props.contextBots.flow.name}</div>
          {props.contextBots.flows.length > 1
            && <ContextMenu classes="float-right" button={mainButton} options={options} />}
        </span>

      </Breadcrumbs>
    </>
  );
};

export default ConversationFlowBreadCrumbs;
